// extracted by mini-css-extract-plugin
export default {"modal":"PositionTemplateModal-module__modal__oTMDn","content":"PositionTemplateModal-module__content__NWgmm"};